//jquery
window.$ = window.jQuery = require('jquery');